import PropTypes from 'prop-types'
import { ModalComponent } from '../ModalComponent'
import styles from './styles.module.css'
import { t } from 'i18next'

export const ArtPendingCancelPopUp = ({
  isOpen,
  onConfirmCancel,
  onContinue,
}) => {
  return (
    <ModalComponent isOpen={isOpen} onClose={onContinue} className={styles.modalContainer}>
      <div className={styles.content}>
        <h2 className={styles.title}>
          {t('cancel_art_pending_pop_up.title') || 'Deseja cancelar esta arte?'}
        </h2>
        <p className={styles.description}>
          {t('cancel_art_pending_pop_up.description') || 'Você poderá iniciar uma nova imediatamente e nenhuma geração será consumida do seu plano.'}
        </p>

        <div className={styles.buttons}>
          <button
            type="button"
            className={styles.primaryButton}
            onClick={onConfirmCancel}
          >
            {t('cancel_art_pending_pop_up.button1') || 'Sim, cancelar'}
          </button>

          <button
            type="button"
            className={styles.secondaryButton}
            onClick={onContinue}
          >
            {t('cancel_art_pending_pop_up.button2') || 'Não, continuar'}
          </button>
        </div>
      </div>
    </ModalComponent>
  )
}

ArtPendingCancelPopUp.propTypes = {
  isOpen: PropTypes.bool,
  onConfirmCancel: PropTypes.func,
  onContinue: PropTypes.func,
}

export default ArtPendingCancelPopUp
